/*-----------------------------------
 * MP hayabusa Customize
 * [このファイルの役割]
 * ・プラグインの読み込み
 * ・URLによるモジュールの実行
 * ・サイト設定
 * ・URLによるCSS読み込み設定
 *-----------------------------------*/

import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import INIT from './modules/init'

// ページ読み込み
import HOME from './page/home'
import CONTENT_HEADER from './plugins/content_header'
import NEWS from './page/news'
import INTRODUCTION from './page/syoukai'

/*****
 * サイト設定
 */
window.siteinfo = {
  viewport:         'width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no',
  // mapApiKeys: {
  //   'local':          'AIzaSyCTB3MSMYkTjSz6l30k79XflmmL_FcOxkg', //development
  //   'www.example.jp': '' //production
  // }
}

/*****
 * サイト初期化
 */
INIT()

switch(location.pathname.replace('main.php','')){
  // トップページ
  case '/': HOME(); break
  case '/news/': NEWS(); break
  case '/syoukai/': INTRODUCTION();break
  case '/seikatsu/':
  case '/recruit/':
  case '/inquiry/':
  case '/profile.php':
  case '/privacy.php':
  case '/sitemap.php': CONTENT_HEADER({
    'privacy': '<h2><span>プライバシーポリシー</span></h2>',
    'sitemap': '<h2><span>サイトマップ</span></h2>',
    'profile': '<h2><span>会社概要</span></h2>',
  }); break
}
